<script setup>
import { useNuxtApp } from 'nuxt/app'
import { onBeforeUnmount, onMounted } from 'vue'
import { useAuthStore } from '~/store/auth.js'

const { $Sentry } = useNuxtApp()

const userStore = useAuthStore()

const { currentEnvironemnt, isProduction } = useEnvironment()

const user = computed(() => userStore.user)

onMounted(() => {
  if ($Sentry && user.value) {
    // User ID only: no name or email (see utils/sentry-event-privacy.js).
    $Sentry.setUser({ id: user.value?.app_user_ref })
  }
})

onBeforeUnmount(() => {
  if ($Sentry) {
    $Sentry.setUser(null)
    $Sentry.close()
  }
})

function handleLogout() {
  userStore.logout()
}
</script>

<template>
  <div>
    <InfoBanner v-if="!isProduction" :content="currentEnvironemnt + ' Environment'" />
    <proclaim-status />
    <div class="flex h-screen w-screen bg-gray-100">
      <side-menu />
      <main class="relative flex h-full flex-1 flex-col gap-6 overflow-auto">
        <navbar @logout="handleLogout" />
        <section class="px-2 pb-6 md:px-6">
          <slot />
        </section>
      </main>
    </div>
  </div>
</template>
